import type { ReactNode } from 'react'
import type { TableProps } from 'antd'

import { Table } from 'antd'
import cx from 'classnames'

import './page-grid.css'
import type { PageGridPaginationProps } from './page-grid-pagination'
import { PageGridPagination } from './page-grid-pagination'

export interface PageGridProps<RecordType extends object = Record<string, unknown>> extends Omit<
  TableProps<RecordType>,
  'pagination'
> {
  wrapperClassName?: string
  contentClassName?: string
  toolbar?: ReactNode
  toolbarClassName?: string
  footerArea?: ReactNode
  footerClassName?: string
  pagination?: false | PageGridPaginationProps
}

export function PageGrid<RecordType extends object = Record<string, unknown>>({
  wrapperClassName,
  contentClassName,
  toolbar,
  toolbarClassName,
  footerArea,
  footerClassName,
  pagination,
  className: tableClassName,
  rootClassName,
  ...tableProps
}: PageGridProps<RecordType>): JSX.Element {
  return (
    <div className={cx('page-grid', wrapperClassName)} data-page-grid>
      {toolbar ? <div className={cx('page-grid__toolbar', toolbarClassName)}>{toolbar}</div> : null}

      <div className={cx('page-grid__content py-2 sm:px-2', contentClassName)}>
        <Table<RecordType>
          {...tableProps}
          pagination={false}
          className={cx('page-grid__table', tableClassName)}
          rootClassName={cx('page-grid__table-root', rootClassName)}
        />
      </div>

      {footerArea ? <div className={cx('px-6 pb-4', footerClassName)}>{footerArea}</div> : null}

      {pagination && typeof pagination === 'object' ? (
        <PageGridPagination {...pagination} className={cx('px-6 pb-6', pagination.className)} />
      ) : null}
    </div>
  )
}
